import { z } from "zod";

import { AudienceDtoSchema } from "../../../../dtos/audiences";

export const PluginAudienceSchema_2024_05_05 = AudienceDtoSchema.omit({
  id: true,
}).extend({
  experienceId: z.string().uuid(),
});
export type PluginAudienceType_2024_05_05 = z.infer<
  typeof PluginAudienceSchema_2024_05_05
>;
